export default __webpack_public_path__ + "static/k2-6bd49ee5a812893506c3a5e1a3799764.jpg";